<ngx-loading-bar [includeSpinner]="false"/>
<router-outlet/>
@if ((isCookieBannerVisible$ | async)) {
  <app-cookie-consent class="cookie-consent-container"/>
}

@if (!loaded()) {
  <div
      class="tw-fixed tw-inset-0 tw-bg-white tw-flex tw-justify-center tw-items-center">
    <app-spinner size="lg"/>
  </div>
}
